<template>
    <div v-if="account">
       <!-- Datos generales -->
        <BCard>
            <BRow >
            <BCol cols="12" md="6" >
                <table class=" mt-xl-0 w-100">
                <ViewData vsIcon="UserIcon" vsLabel="Name" :vsValue="account.name"  />
                <ViewData vsIcon="MailIcon" vsLabel="Email" :vsValue="account.email" />
                <ViewData vsIcon="PhoneIcon" vsLabel="Phone" :vsValue="account.phone"  />
                </table>
            </BCol>
            <BCol cols="12" md="6" >
                <table class=" mt-xl-0 w-100">
                <ViewData vsIcon="CheckCircleIcon" vsLabel="Status" :vsValue="account.status" vsCheckbox />
                <ViewData vsIcon="CheckCircleIcon" vsLabel="Acepta recibir notificaciones por correo electrónico" :vsValue="account.notif_email" vsCheckbox />

                </table>
            </BCol>
            </BRow>

            <BRow>
            <BCol cols="12" class="mt-2">
                <div class="d-flex flex-wrap">
                    <BButton :to="{ name: 'accounts-edit', params: { id: account.id } }" variant="primary"> {{$t('Edit')}} </BButton>
                    <BButton variant="outline-danger" class="ml-1" @click="deletePopupAxios(account.id, `accounts/${account.id}`, 'accounts')"> {{$t('Delete')}} </BButton>
                </div>
            </BCol>
            </BRow>
        </BCard>

        <BCard>
            <BRow> <BCol cols="12"> <h4 class=""><b>Dirección</b></h4> </BCol> </BRow>
            <BRow>
                <BCol cols="12" md="6" >
                <table class="mt-xl-0 w-100">
                    <ViewData vsIcon="MapIcon" vsLabel="Address" :vsValue="account.billing_address"  />
                    <ViewData vsIcon="MapPinIcon" vsLabel="City" :vsValue="account.billing_city" />
                    <ViewData vsIcon="UserIcon" vsLabel="Postal code" :vsValue="account.billing_postal_code" />

                </table>
                </BCol>
                <BCol cols="12" md="6" >
                <table class="mt-xl-0 w-100">
                    <ViewData vsIcon="CompassIcon" vsLabel="Province" :vsValue="account.province ? account.province.name : '' "  />
                    <ViewData vsIcon="CompassIcon" vsLabel="Country" :vsValue="account.country ? account.country.name : ''" />
                </table>
                </BCol>
            </BRow>
        </BCard>

        <BCard>
            <BRow>
            <BCol cols="12"> <h4 class=""><b>Observaciones</b></h4> </BCol>
            </BRow>
            <BRow>
                <BCol>
                {{ account.notes }}
                </BCol>
            </BRow>
        </BCard>
    </div>

</template>

<script>
import {  inject } from '@vue/composition-api';
import ViewData from '@/components/ViewData.vue';
import { BCard, BCol, BRow, BButton } from 'bootstrap-vue';
import popups from '@/hooks/popups';

export default {
    components: { BRow, BCard, BCol, ViewData, BButton },
    setup() {
        const { deletePopupAxios } = popups()
        const account = inject('account')
        return {account, deletePopupAxios}
    },
}
</script>